import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logins:1,
    business_id:1,
    globalData:'场馆'
  },
  mutations: {
    // 场馆名称
    setGlobalData(state,data){
      state.globalData = data
    }
    // 微信登录code刷新
    // refreshCode(state, val) {
    //   //(val);
    //   state.logins = val
    // },
    // // 公司id
    // reBusinessId(state, val) {
    //   //(val);
    //   state.business_id = val
    // }
  },
  actions: {
    updateGlobalData({ commit }, data) {
      commit('setGlobalData', data);
    }
  },
  modules: {}
})